module.exports = __webpack_public_path__ + "static/media/adv-img3.5f646909.jpg";